import { TerminalState } from './TerminalState';

export function NotFoundPage() {
  return (
    <TerminalState
      copy={{
        tone: 'warning',
        title: 'Page not found',
        body: 'This PlayerUp page does not exist.',
      }}
    />
  );
}
